{
  "$schema": "https://design-tokens.github.io/community-group/format/",
  "name": "Gabinete Central — proposta visual",
  "version": "0.1.0-proposta",
  "status": "Artefato de design, sem aplicação, persistência ou integração. Valores visuais propostos; dados de tela fictícios.",
  "themes": {
    "light": {
      "background": "#F3F6F9",
      "surface": "#FFFFFF",
      "surfaceRaised": "#F8FAFC",
      "ink": "#14263A",
      "muted": "#596B7D",
      "border": "#D9E2EA",
      "brand": "#143651",
      "brandInk": "#FFFFFF",
      "accent": "#0C756E",
      "accentInk": "#FFFFFF",
      "accentTint": "#E5F3EF",
      "warn": "#805100",
      "warnTint": "#FFF3D6",
      "danger": "#A13642",
      "dangerTint": "#FCECEF",
      "info": "#235C98",
      "infoTint": "#EAF2FC",
      "sidebar": "#102B46",
      "sidebarInk": "#F3F7FB",
      "sidebarMuted": "#B6C6D6",
      "focus": "#006EAE",
      "controlBorder": "#7C8C9C"
    },
    "dark": {
      "background": "#101A26",
      "surface": "#182638",
      "surfaceRaised": "#1D2E42",
      "ink": "#E7EEF5",
      "muted": "#A8B8C9",
      "border": "#34475C",
      "brand": "#B9D5F0",
      "brandInk": "#102B46",
      "accent": "#70D3C0",
      "accentInk": "#0B2E2A",
      "accentTint": "#173E3C",
      "warn": "#F4CC7F",
      "warnTint": "#44371E",
      "danger": "#F3A5AF",
      "dangerTint": "#492D38",
      "info": "#A6CCFA",
      "infoTint": "#223B56",
      "sidebar": "#0C2137",
      "sidebarInk": "#F3F7FB",
      "sidebarMuted": "#B6C6D6",
      "focus": "#9BD7FF",
      "controlBorder": "#6B7F95"
    }
  },
  "typography": {
    "fontSans": "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    "fontDisplay": "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    "fontMono": "Consolas, 'Courier New', monospace",
    "sizeEyebrow": "11px",
    "sizeLabel": "12px",
    "sizeSmall": "13px",
    "sizeBody": "14px",
    "sizeLead": "16px",
    "sizeHeading": "28px",
    "sizeDisplay": "38px",
    "lineHeight": "1.5",
    "weightBody": 400,
    "weightMedium": 600,
    "weightStrong": 700
  },
  "spacing": {
    "space1": "4px",
    "space2": "8px",
    "space3": "12px",
    "space4": "16px",
    "space5": "24px",
    "space6": "32px",
    "space7": "48px",
    "space8": "64px"
  },
  "radii": {
    "radiusSmall": "8px",
    "radiusMedium": "12px",
    "radiusLarge": "16px",
    "radiusHero": "20px",
    "radiusPill": "999px"
  },
  "shadows": {
    "shadowCard": "0 3px 16px rgba(16,43,70,.035)",
    "shadowFloat": "0 14px 48px rgba(8,25,43,.2)",
    "shadowFocus": "0 0 0 3px rgba(0,110,174,.2)"
  },
  "motion": {
    "durationFast": "120ms",
    "durationBase": "180ms",
    "durationPanel": "240ms",
    "ease": "cubic-bezier(.2,.7,.2,1)",
    "reducedMotion": "Respect prefers-reduced-motion; remove transitions and decorative animation."
  },
  "layout": {
    "sidebarWidth": "236px",
    "contentMax": "1440px",
    "mobileBreakpoint": "760px",
    "compactBreakpoint": "1100px",
    "touchTarget": "44px",
    "mobileNavigation": [
      "Início",
      "Demandas",
      "Visitas",
      "Calendário",
      "Mais"
    ]
  },
  "notes": [
    "Proposta visual, sem aprovação de regra de negócio ou valores de recompensa.",
    "Estado não depende apenas de cor; rótulos e ícones acompanham a semântica.",
    "Ofícios são apresentados somente no layout de computador; o protótipo não implementa autorização.",
    "Cores pretendem oferecer contraste legível; não há declaração de conformidade WCAG sem auditoria e tarefas reais.",
    "Temas e navegação da prévia são locais e se perdem ao recarregar."
  ],
  "fixed": {
    "brandOutline": "#648098",
    "brandGlyph": "#A6E5D8",
    "sidebarScrollbar": "#456079",
    "sidebarHover": "#1D3B56",
    "sidebarActive": "#23465F",
    "sidebarActiveInk": "#FFFFFF",
    "sidebarActiveEdge": "#89DFCB",
    "sidebarCount": "#36546D",
    "sidebarBorder": "#36516B",
    "sidebarAvatar": "#2F5669",
    "sidebarAvatarInk": "#B7F0E3",
    "heroInk": "#F1F8FA",
    "heroOutline": "#3A6775",
    "heroEyebrow": "#A9C6D1",
    "heroMuted": "#B8CFD9",
    "heroTrack": "#2B4D63",
    "heroProgress": "#93DECE",
    "heroMetric": "#CEE5EA",
    "heroPill": "#214C5B",
    "heroPillInk": "#B5F0E1",
    "heroPillBorder": "#426A75",
    "loginLine": "#83B9BC",
    "rankStageStart": "#143651",
    "rankStageEnd": "#0E4C59",
    "rankStageInk": "#F1F8FA",
    "rankStageMuted": "#C3D8E1",
    "rankGold": "#F5CF78",
    "rankGoldFace": "#E8B44E",
    "rankGoldInk": "#503600",
    "rankSilver": "#D4E1EB",
    "rankSilverFace": "#A9BFCD",
    "rankSilverInk": "#263F52",
    "rankBronze": "#E9C7AE",
    "rankBronzeFace": "#CA9B77",
    "rankBronzeInk": "#47301F",
    "rankStageOutline": "#507383"
  }
}
